import "./assets/css/style.scss";
import "./assets/css/responsive.scss";
import "./assets/css/reset.scss";
import Footer from "./components/Footer";
import { ResetIcon, PauseIcon, SkipIcon, DoneIcon } from "./constants/icons";
import { useState, useEffect } from "react";
import Setting from "./components/Setting";
import PomodoroTypes from "./components/PomodoroTypes";
import { convertTimeToText } from "./constants/methods";
import ControlButton from "./components/ControlButton";

import useSound from "use-sound";
import click from "./assets/sound/click.mp3"
import lap from "./assets/sound/lap.mp3"




function App() {
    //sounds
    const [playClick] = useSound(click)
    const [playLap] = useSound(lap)

    const [timerMode, setTimerMode] = useState("study");

    const [studyTime, setStudyTime] = useState(30);
    const [breakTime, setBreakTime] = useState(5);

    const [defaultStudyTime, setDefaultStudyTime] = useState(30);
    const [defaultBreakTime, setDefaultBreakTime] = useState(5);

    const [timer, setTimer] = useState(defaultStudyTime * 60);

    const [paused, setPaused] = useState(true);

    const changeBy = 1;
    const max = 60;

    const studyTimeSet = (value) => {
        if (value == "-") {
            if (studyTime > changeBy) {
                setStudyTime(studyTime - changeBy);
            }
        } else if (value == "+") {
            if (studyTime + changeBy <= max) {
                setStudyTime(studyTime + changeBy);
            }
        }
    };

    const breakTimeSet = (value) => {
        if (value == "-") {
            if (breakTime > changeBy) {
                setBreakTime(breakTime - changeBy);
            }
        } else if (value == "+") {
            if (breakTime + changeBy <= max) {
                setBreakTime(breakTime + changeBy);
            }
        }
    };

    useEffect(() => {
        updateTimer();
    }, [timer]);

    useEffect(() => {
        if (paused == false) {
            updateTimer();
        } else {
            document.title = document.title + " / PAUSED";
        }
    }, [paused]);

    useEffect(() => {
        if (timerMode == "study") {
            setTimer(defaultStudyTime * 60);
        } else if (timerMode == "break") {
            setTimer(defaultBreakTime * 60);
        }
    }, [defaultStudyTime, defaultBreakTime]);

    const reset = () => {
        playClick();
        const ans = window.confirm(
            "Are you sure you want to reset the pomodoro timer?"
        );
        if (ans == true) {
            setPaused(true);
            setTimeout(() => {
                studyTimeSet(30);
                breakTimeSet(5);
                setDefaultStudyTime(30);
                setDefaultBreakTime(5);
                setTimer(studyTime * 60);
            }, 10);
        }
    };

    const askWhileSkip = () => {
        const ans = window.confirm("Are you sure you want to skip study?");
        return ans
    }

    const skip = (ask) => {
        playClick();
        if(ask){
            if(!askWhileSkip()){
                return
            }
        }
        playLap()
        if (timerMode == "study") {
            setTimerMode("break");
            document.body.className = "break-bg";
            //document.body.style.animation = "bg-to-break 2s";
            setPaused(true);
            setTimer(breakTime * 60);
        } else if (timerMode == "break") {
            document.body.className = "";
            //document.body.style.animation = "bg-to-study 2s";
            setTimerMode("study");
            setPaused(true);
            setTimer(studyTime * 60);
        }
    };

    const doneChange = () => {
        playClick()
        setDefaultStudyTime(studyTime);
        setDefaultBreakTime(breakTime);
    };

    function updateTimer() {
        if (paused) {
            return;
        }
        setTimeout(() => setTimer(timer - 1), 1000);
        document.title = `[${convertTimeToText(
            Math.floor(timer / 60)
        )}:${convertTimeToText(timer % 60)}] - ${
            timerMode.charAt(0).toUpperCase() + timerMode.slice(1)
        }`;
        console.log(timer);

        if(timer <= 0){
            skip(false)
        }
    }

    return (
        <div className="app">
            <div className="main">
                <PomodoroTypes />

                <input
                    className="pomodoro-name"
                    autoComplete="false"
                    autoCapitalize="false"
                    autoFocus
                    spellCheck="false"
                    type="text"
                    placeholder="Name your pomodoro..."
                />

                <h2 className="text">
                    {timerMode == "study" ? "Study Time!" : "Break Time!"}
                </h2>

                <h1 className="timer">
                    {/* <span className="round-bg minute"></span>
                    <span className="round-bg second"></span> */}
                    {convertTimeToText(Math.floor(timer / 60))}:
                    {convertTimeToText(timer % 60)}
                </h1>

                <div className="actions">
                    <div
                        className="settings"
                        style={{ opacity: paused ? 1 : 0.3 }}
                    >
                        <div
                            className="obstacle"
                            style={{ display: paused ? "none" : "block" }}
                        ></div>
                        <Setting
                            name="Study"
                            setTime={studyTimeSet}
                            time={studyTime}
                        />
                        <Setting
                            name="Break"
                            setTime={breakTimeSet}
                            time={breakTime}
                        />
                    </div>

                    <button
                        className="button-done"
                        onClick={() => doneChange()}
                        hidden={
                            defaultStudyTime == studyTime &&
                            defaultBreakTime == breakTime ||
                            !paused
                        }
                    >
                        <DoneIcon width={26} height={26} />
                    </button>
                    <div className="buttons">
                        <button
                            onClick={() => reset()}
                            className="buttons-reset"
                            type="button"
                        >
                            <ResetIcon />
                        </button>

                        <button
                            onClick={() => skip(true)}
                            className="buttons-skip"
                            type="button"
                        >
                            <SkipIcon />
                        </button>

                        <ControlButton playClick={playClick} paused={paused} setPaused={setPaused} />
                    </div>
                </div>
            </div>
            <br />
            <Footer />
        </div>
    );
}

export default App;
